module.exports = __webpack_public_path__ + "assets/icon-search-gray-border.01f42d0f.svg";